import { factoryImage } from "@/services/images";
import { type CartItem } from "@/services/marketplace/cart";
import { type MaybeRef, unref } from "vue";

export function useCartItemImages(cartItem: MaybeRef<CartItem | undefined>) {
  const images = computed(() => {
    const itemUnrefed = unref(cartItem);
    if (itemUnrefed === undefined) {
      return [];
    } else {
      const name = itemUnrefed.productName;
      return itemUnrefed.productImages.map((rawImageData) => factoryImage(rawImageData.id, rawImageData.imageUrl, name));
    }
  });

  const coverImage = computed(() => {
    return images.value[0];
  });

  return {
    images,
    coverImage,
  };
}
